@if (active) {
  <div class="d-flex flex-column flex-shrink-0 p-3 text-white sidebar">
    <ul class="nav nav-pills flex-column mb-auto">
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': isSelected(['/hospitals'])}" routerLink="/hospitals">
          <app-icon icon="clipboard" iconClass="nav-icon"></app-icon> Organizations
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': isSelected(['/customers'])}" routerLink="/customers">
          <app-icon icon="clipboard" iconClass="nav-icon"></app-icon> Customers
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': isSelected(['/users'])}" routerLink="/users">
          <app-icon icon="users" iconClass="nav-icon"></app-icon> Users
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': isSelected(['/b2c'])}" routerLink="/b2c">
          <app-icon icon="users" iconClass="nav-icon"></app-icon> B2C/B2B2C
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': isSelected(['/locations'])}" routerLink="/locations">
          <app-icon icon="map-pin" iconClass="nav-icon"></app-icon> Locations
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': isSelected(['/venues'])}" routerLink="/venues">
          <app-icon icon="map-pin" iconClass="nav-icon"></app-icon> Venues
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': isSelected(['/providers'])}" routerLink="/providers">
          <app-icon icon="compass" iconClass="nav-icon"></app-icon> Transport Companies
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': isSelected(['/promo-codes'])}" routerLink="/promo-codes">
          <app-icon icon="package" iconClass="nav-icon"></app-icon> Promo Codes
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': isSelected(['/payer'])}" routerLink="/payer/plans">
          <img class="nav-icon" src="assets/images/payers.svg" /> Payers
        </a>
        <ul class="nested-nav">
          <li class="nav-item">
            <a class="nav-link" [ngClass]="{'active': isSelected('/payer/plans')}" routerLink="/payer/plans">Plans</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [ngClass]="{'active': isSelected('/payer/carriers')}" routerLink="/payer/carriers">Carriers</a>
          </li>
        </ul>
      </li>
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': isSelected(['/reports'])}" routerLink="/reports">
          <app-icon icon="package" iconClass="nav-icon"></app-icon> Reports
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{'active': isSelected(['/rideshare-availability'])}" routerLink="/rideshare-availability">
          <app-icon icon="package" iconClass="nav-icon"></app-icon> Rideshare Availability
        </a>
      </li>
    </ul>
  </div>
}
